import * as angular from 'angular';
import * as _ from "lodash";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsEnums} from "../../shared/dto/aps.enums";
import UIUtilityServiceName, {UIUtilityService} from "../../services/utility/uiUtility.service";
import template from './viewDefectType.tpl.html';

let requires = [UIUtilityServiceName];

interface ViewDefectTypeController {
  defectType: apsViewModels.DefectTypeDetails;
  wareClasses: {
    name: string;
    severity: string;
  }[];
  getSeverityName(severity: apsEnums.Severity): string;
  getScopeName(scope: apsEnums.UnqualificationScope): string;
  getThreshold(threshold: number): string;
  close(): void;
}

export interface ViewDefectTypeData {
  defectType: apsViewModels.DefectTypeDetails;
  wareClasses: apsViewModels.WareClassSelection[];
}

export function openViewDefectType(data: ViewDefectTypeData,
                                   $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'ViewDefectTypeCtrl as vm',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

function getSeverityName(severity: apsEnums.Severity): string {
  return apsEnums.Severity[severity];
}

function getThreshold(threshold: number): string {
  if (threshold === 0) {
    return 'None';
  }
  if (threshold > 0) {
    return (threshold * 100).toFixed() + '%';
  }
  return 'All';
}

export default angular.module('aps.controller.viewDefectType', requires)
  .controller('ViewDefectTypeCtrl', viewDefectTypeCtrl)
  .name;

function viewDefectTypeCtrl(
  $modalInstance: mm.foundation.modalInstance,
  data: ViewDefectTypeData,
  uiUtilityService: UIUtilityService
) {
  let vm = {} as ViewDefectTypeController;
  vm.defectType = data.defectType;
  let unqualificationScopes = uiUtilityService.getListOptionsFromEnum(apsEnums.UnqualificationScope);

  vm.wareClasses = [];
  vm.defectType.wareClasses.forEach(wc => {
    if (wc.severity === vm.defectType.severity) {
      return;
    }

    let wareClass = _.find(data.wareClasses, {id: wc.wareClassId});
    if (!wareClass) {
      return;
    }

    vm.wareClasses.push({
      name: wareClass.name,
      severity: getSeverityName(wc.severity)
    });
  });

  function getScopeName(scope: apsEnums.UnqualificationScope): string {
    let scopeItem = _.find(unqualificationScopes, {value: scope});
    return scopeItem ? scopeItem.text : '';
  }

  vm.getScopeName = getScopeName;
  vm.getSeverityName = getSeverityName;
  vm.getThreshold = getThreshold;

  vm.close = function() {
    $modalInstance.close();
  };

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/defectTypes/viewDefectType.controller.ts